import script from "./UCCodeScannerConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./UCCodeScannerConfig.vue?vue&type=script&setup=true&lang=js"

import "./UCCodeScannerConfig.vue?vue&type=style&index=0&id=9ddb60e4&lang=scss"

const __exports__ = script;

export default __exports__